import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext.jsx';
import Layout from './components/common/Layout.jsx';
import LoginPage from './pages/LoginPage.jsx';
import TicketsPage from './pages/TicketsPage.jsx';

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: 'var(--text2)' }}>
      Loading…
    </div>
  );

  if (!user) return (
    <Routes>
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );

  return (
    <Layout>
      <Routes>
        <Route path="/tickets" element={<TicketsPage />} />
        <Route path="*"        element={<Navigate to="/tickets" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: { background: 'var(--bg2)', color: 'var(--text)', border: '1px solid var(--border)' },
        }}
      />
      <AppRoutes />
    </AuthProvider>
  );
}
